import { Check } from 'lucide-react';
import { Fragment } from 'react';

const LABELS = ['Pessoa & canal', 'Categoria Meta', 'Template & preview', 'Confirmar'];

/**
 * Trilha de passos (1-4) do fluxo de iniciação proativa. Convertido verbatim do
 * `step-rail` do mockup (compounds-2b.css).
 */
export function StepRail({ step }: { step: number }): JSX.Element {
  return (
    <div className="step-rail">
      {LABELS.map((lbl, i) => {
        const n = i + 1;
        const done = step > n;
        const active = step === n;
        return (
          <Fragment key={lbl}>
            <span
              className={
                'step-rail__step' +
                (active ? ' step-rail__step--active' : '') +
                (done ? ' step-rail__step--done' : '')
              }
            >
              <span className="step-rail__num">{done ? <Check size={10} /> : n}</span>
              {lbl}
            </span>
            {i < LABELS.length - 1 && <span className="step-rail__sep">›</span>}
          </Fragment>
        );
      })}
    </div>
  );
}
